import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CropIcon(props: IconProps) {
    return <Icon {...props} iconKey={"crop"}/>
}
